import React, { memo } from 'react';
import { CardGrid, SignupCard, Typography } from 'common/components';
import { RelatedService } from 'modules/related-services';
import { formatToRub } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { BATHROOM_CDN_PATH } from '../../../../old-bathroom-constants';
import { descriptionStyle } from './card-content-styles';

type CardContentProps = {
  actualMeasure: RelatedService;
};

/**
 * Блок карточек с информацией о замерах
 */
export const CardContent = memo(({ actualMeasure }: CardContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography className={descriptionStyle} size="body_long" variant="m">
        {t('sizing-section.description')}
      </Typography>
      <CardGrid>
        <SignupCard
          buttonProps={{
            ariaLabel: t('sizing-section.measure.button-label'),
            elementBlock: 'landingVannuyuKomnatu',
            elementName: t('sizing-section.measure.button-name'),
            elementText: t('sizing-section.title'),
            href: actualMeasure.serviceURL,
            label: t('sizing-section.measure.button-name'),
            title: t('sizing-section.measure.button-label') || '',
            rel: 'noreferrer',
            target: '_blank',
          }}
          description={t('sizing-section.measure.description') || ''}
          logo={{
            alt: t('sizing-section.measure.img-alt'),
            src: `${BATHROOM_CDN_PATH}/sizing/sizing.png/sizing.png`,
          }}
          title={t('sizing-section.measure.title', { price: formatToRub(actualMeasure.price) })}
        />

        <SignupCard
          buttonProps={{
            ariaLabel: t('sizing-section.instruction.button-label'),
            elementBlock: 'landingVannuyuKomnatu',
            elementName: t('sizing-section.instruction.button-name'),
            elementText: t('sizing-section.title'),
            href: '/advice/santehnika/kak-izmerit-vannuyu-komnatu/',
            label: t('sizing-section.instruction.button-name'),
            title: t('sizing-section.instruction.title') || '',
          }}
          description={t('sizing-section.only-instruction.description') || ''}
          logo={{
            alt: t('sizing-section.instruction.button-label'),
            src: `${BATHROOM_CDN_PATH}/sizing/instruction.png/instruction.png`,
          }}
          title={t('sizing-section.instruction.title')}
        />
      </CardGrid>
    </>
  );
});
